<script setup lang="ts">
import { useI18n } from '@/composable/useI18n'

defineProps<{
  periodLabel: string
}>()

const { t } = useI18n()
</script>

<template>
  <div class="mb-3 flex flex-wrap items-center justify-between gap-3 text-xs">
    <p
      v-if="periodLabel"
      class="inline-flex rounded-none border border-stroke bg-gray-2 px-2 py-1 font-medium text-gray-700">
      {{ t('daily_temperature.table.period_chip', { label: periodLabel }) }}
    </p>
    <span v-else aria-hidden="true" />

    <p class="flex items-center gap-1.5 text-slate-500">
      <span class="inline-block h-3 w-3 bg-red-500" aria-hidden="true" />
      {{ t('daily_temperature.legend.setpoint') }}
    </p>
  </div>
</template>
